import React from 'react'
import t from 'prop-types'

const PillarContentHeader = ({ data }) => {
  const Tag = `${data.tag}`
  return (
    <Tag className="text-black font-bold text-3xl lg:text-4xl leading-none mt-16 lg:mt-20 mb-5 max-w-screen-md mx-auto px-5 lg:px-0">
      {data.text}
    </Tag>
  )
}

PillarContentHeader.propTypes = {
  data: t.object,
}

PillarContentHeader.defaultProps = {}

export default PillarContentHeader
